<div class="dropdown user_notification" dropdown autoClose="outside">
  <button title="Notifications" class="btn btn-white px-2 notification-btn" type="button" data-bs-toggle="dropdown"
    aria-expanded="false">
    <img src="assets/images/dashboard/notification-bing.svg" alt="Notification" width="28" height="28" />
    <span class="translate-middle translate-middle-badge badge rounded-pill bg-danger">
      {{ unreadCount }}
    </span>
  </button>


  <ul class="dropdown-menu p-3" style="width: 350px; max-height: 400px; overflow: hidden">
    <div class="d-flex justify-content-between align-items-center ms-1 my-2">
      <h5 class="fw-bold mb-0">Notifications</h5>
      <div class="form-check">
        <button type="button" class="mark-all-btn" (click)="markAllAsRead()" [disabled]="unreadCount === 0">
          Mark all as read
        </button>
      </div>
    </div>
    <hr />

    <div class="notifications-container" style="height: 300px; overflow-y: auto" (scroll)="onScroll($event)">
      <div *ngIf="isLoading" class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 text-muted small">Loading notifications...</p>
      </div>

      <div *ngIf="!isLoading">
        <div *ngFor="let notification of notifications" class="notification-item mb-2">
          <div class="d-flex align-items-start">
            <div
              class="user-initial flex-shrink-0 bg-light rounded-circle d-flex align-items-center justify-content-center me-2"
              style="width: 36px; height: 36px;">
              <span class="fw-bold">{{ notification?.fromUser?.full_name?.[0] }}</span>
            </div>

            <div (click)="notificationNavigation($event, notification, true)" class="flex-grow-1">
              <h6 class="fw-semibold">{{ notification?.fromUser?.full_name }}</h6>
              <div>{{ notification?.title }}</div>
              <div class="d-flex justify-content-between align-items-center mt-1">
                <div class="text-muted small">{{ notification?.created_at | date: 'short' }}</div>
                <button (click)="notificationNavigation($event, notification, false)" class="btn btn-link btn-sm p-0">
                  <span *ngIf="notification?.status_id == 2">
                    Mark as Read <i class="bi bi-envelope-fill"></i>
                  </span>
                  <span *ngIf="notification?.status_id == 1">
                    <i class="bi bi-envelope-open"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <hr />
        </div>

        <div *ngIf="notifications.length === 0" class="text-center mt-3">
          <p>No Notifications</p>
        </div>

        <div *ngIf="isLoadingMore" class="text-center py-3">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="visually-hidden">Loading more...</span>
          </div>
        </div>
      </div>
    </div>
  </ul>

</div>